module.exports = __webpack_public_path__ + "static/oldMandesktop-6051ddb26f9654623b01672236b68977.png";